module.exports = __webpack_public_path__ + "img/adopciones2.b26633ec.jpg";